import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const navItems = [
    { label: '회사소개', id: 'about', href: '' },
    { label: '전립선암과 영양소', id: 'nutrition', href: '' },
    { label: '제품소개', id: 'products', href: '' },
    { label: '구매하기', id: 'purchase', href: 'https://smartstore.naver.com/proactivecare' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm border-b border-navy-100' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <button onClick={() => scrollTo('intro')} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/f709ae3db271d6c0d8bf92ab254501ef.png"
            alt="PAC KOREA 전립상회 로고"
            className="h-10 md:h-12 w-auto object-contain"
          />
          <span className={`hidden sm:inline-flex items-center gap-1.5 text-[10px] font-semibold tracking-wide border rounded-full px-2.5 py-1 whitespace-nowrap transition-colors duration-300 ${
            scrolled
              ? 'border-[#d4a843]/50 text-[#c49a2a] bg-[#fdf8ee]'
              : 'border-[#f0c040]/50 text-[#f0c040] bg-white/10'
          }`}>
            <i className="ri-award-fill text-xs" />
            2024 소비자평가 우수상
          </span>
        </button>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <li key={item.id}>
              {item.href ? (
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap relative group ${
                    scrolled ? 'text-[#1a2b4a]' : 'text-white'
                  }`}
                >
                  {item.label}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#1a2b4a] group-hover:w-full transition-all duration-300" />
                </a>
              ) : (
                <button
                  onClick={() => scrollTo(item.id)}
                  className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap relative group ${
                    scrolled ? 'text-[#1a2b4a]' : 'text-white'
                  }`}
                >
                  {item.label}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#1a2b4a] group-hover:w-full transition-all duration-300" />
                </button>
              )}
            </li>
          ))}

        </ul>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="메뉴 열기"
        >
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? 'bg-[#1a2b4a]' : 'bg-white'}`} />
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? 'bg-[#1a2b4a]' : 'bg-white'}`} />
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? 'bg-[#1a2b4a]' : 'bg-white'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            item.href ? (
              <a
                key={item.id}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1a2b4a] text-sm font-medium text-left cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ) : (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className="text-[#1a2b4a] text-sm font-medium text-left cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </button>
            )
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
